import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Vendedor } from "@/shared/types/vendedor";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteVendedor(id: string): Promise<Vendedor> {
    await sleep(1000);
    const response = await api.delete("vendedores/" + id);
    return response.data;
}

export function useDeleteVendedorMutation(id: string, mutationConfig: MutationConfig<Vendedor> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteVendedor(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["vendedores"] });
        },
    })
}

export interface DeleteVendedorMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Vendedor>,
    children?:(mutationResult:MutationResult<Vendedor>)=>ReactNode
}

export function DeleteVendedorMutation({
    id,
    children,
    mutationConfig
}:DeleteVendedorMutationProps){
    const mutationResult = useDeleteVendedorMutation(id, mutationConfig);
    return children&&children(mutationResult)
}